export default __webpack_public_path__ + "static/media/logo_aws.959be657.svg";